/** @format */

import React from "react";
import { Bar } from "react-chartjs-2";
// import Chart from "chart.js/auto";
const BankStatementAnalysis = () => {

  const cardsData = [
    { label: "Average credit", value: "500, 890 NGN" },
    { label: "Average debit", value: "45,680 NGN" },
    { label: "Average balance", value: "45,680 NGN" },
    { label: "Monthly average expense", value: "45,680 NGN" },
    { label: "Monthly average income", value: "500, 890 NGN" },
    { label: "Re-occurring expense", value: "45,680 NGN" },
    { label: "Monthly average expense", value: "45,680 NGN" },
  ];

  // Sample data for the bar graph
  const graphData = {
    labels: [
      "Jan",
      "Feb",
      "Mar",
      "Apr",
      "May",
      "Jun",
      "Jul",
      "Aug",
      "Sep",
      "Oct",
      "Nov",
      "Dec",
    ],
    datasets: [
      {
        label: "Income",
        data: [
          2000, 1800, 2200, 2500, 3000, 2800, 3200, 3500, 3800, 4000, 4200,
          4500,
        ],
        backgroundColor: "#DCDB4C",
        borderColor: "rgba(54, 162, 235, 1)",
      },
      {
        label: "Expenses",
        data: [
          1500, 1400, 1600, 1700, 1800, 1900, 2000, 2100, 2200, 2300, 2400,
          2500,
        ],
        backgroundColor: "#4C4DDC",
        borderColor: "rgba(255, 99, 132, 1)",
      },
    ],
  };

  return (
    <div>
      <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-4">
        {cardsData.map((card, index) => (
          <div
            key={index}
            className="bg-[#F5F5FF] rounded-md border border-[#DFE0F3] shadow-sm text-sm p-4 "
          >
            <h3 className="text-[#616161] font-medium mb-2">{card.label}</h3>
            <p className="text-md bold">{card.value}</p>
          </div>
        ))}
      </div>
      <div className="mt-8">
        <h3 className="text-lg font-medium mb-4">
          Income and Expenses in the Last 12 Months
        </h3>
        <div className="w-full p-2">
          <Bar
            data={graphData}
            options={{
              maintainAspectRatio: false,
              scales: {
                x: {
                  stacked: true,
                  grid: {
                    display: false,
                  },
                },
                y: {
                  stacked: true,
                  grid: {
                    display: false,
                    drawBorder: false,
                  },
                  ticks: {
                    display: false,
                  },
                },
              },

              layout: {
                padding: {
                  left: 10,
                  right: 10,
                  top: 10,
                  bottom: 10,
                },
              },
              barThickness: 10,
              borderRadius: 10,
            }}
          />
        </div>
      </div>
    </div>
  );
};

export default BankStatementAnalysis;
